import ImageMapGuideClass, * as ImageMapGuideModule from './../../node_modules/ol/source/ImageMapGuide.js';

class ImageMapGuide extends ImageMapGuideClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageMapGuideModule) {
    if (key !== "default") {
        ImageMapGuide[key] = ImageMapGuideModule[key];
    }
}

export default ImageMapGuide;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageMapGuide.js';